module.exports = __webpack_public_path__ + "img/flag1.768372c5.svg";